import I18N from '@leverege/i18n';
import { Text } from '@leverege/ui-elements';
import { useMemo } from 'react';
import { DateTime } from 'luxon';
import TimelineUtil from "../TimelineUtil.js";
import { jsx as _jsx } from "react/jsx-runtime";
const id = 'rsrc.dataViewers.actions.ScrubTime';
const {
  t
} = I18N.ns(id);
export default {
  id,
  name: t('name'),
  matches: {
    client: 'TimelineScrubber',
    use: 'playBar'
  },
  layout: {
    sort: 'yy'
  },
  handles: () => true,
  appearance: ({
    context
  }) => {
    return {
      name: t('name')
    };
  },
  customComponent: ScrubTime
};
function ScrubTime({
  context
}) {
  const {
    scrubTime
  } = context;
  const formattedScrubTime = useMemo(() => {
    return TimelineUtil.coerceDateTime(scrubTime).toLocaleString(DateTime.DATETIME_SHORT, {
      hour: '2-digit'
    });
  }, [scrubTime]);
  return /*#__PURE__*/_jsx(Text, {
    variant: "timelineScrubberTime",
    children: formattedScrubTime || 'Select a Time Range to Start'
  });
}